module.exports = __webpack_public_path__ + "img/ao.d774acce.svg";